import { Page } from "@/models/page-models/Page";

export const SampleMasterByCustomer: Page = {
  "path": "sample-master/:customerId",
  "name": "Sample Master",
  "props": {
    "data": {
      "title": "Sample",
      "printable": "FALSE",
      "url": "sample-master/:customerId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.customer",
                  "label": "Select Customer",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "redirectToSampleMaster",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/sample-master/{{fetchedData.customer}}"
                      },
                      "name": "redirectToSampleMaster"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "button",
                  "label": "Create Sample",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "createNewSample",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/new-sample",
                        "arg2Key": "queryParams",
                        "arg2Value": "{\"customer\":\"{{fetchedData.customer}}\"}"
                      },
                      "name": "createNewSample"
                    }
                  ],
                  "disabled": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.status}},'),==,'Closed Prospect'),||,fn(LOGICAL,fn(CONCAT,',{{fetchedData.customerDetails.status}},'),==,'Closed Customer'))",
                  "showIf": "fn(MATCH_DEPARTMENT,SALES)",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Open",
              "bracketValueFormula": "{{fetchedData.openSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Open Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.openSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.openSampleSearchForm.page",
                        "serverItemsLengthVariable": "fetchedData.openSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.openSampleSearchForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOpenSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.openSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.openSampleSearchForm"
                            },
                            "name": "getOpenSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending",
              "bracketValueFormula": "{{fetchedData.pendingSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.pendingSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveSample",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "approveSample"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.pendingSampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.pendingSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.pendingSampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getPendingSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.pendingSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.pendingSampleSearch"
                            },
                            "name": "getPendingSamples"
                          }
                        ]
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Production",
              "bracketValueFormula": "{{fetchedData.productionSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Production Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.productionSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Mark as Produced",
                          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Production | Manager))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsOpen",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/mark-produced",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "markAsOpen"
                            }
                          ]
                        },
                        {
                          "label": "Hold Sample",
                          "showIf": "fn(MATCH_DEPARTMENT,QA)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsProductionHold",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/hold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "markAsProductionHold"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.productionSampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.productionSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.productionSampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getProductionSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.productionSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.productionSampleSearch"
                            },
                            "name": "getProductionSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Produced",
              "bracketValueFormula": "{{fetchedData.producedSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Produced Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.producedSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Hold Sample",
                          "showIf": "fn(MATCH_DEPARTMENT,QA)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsProductionHold",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/hold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "markAsProductionHold"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.producedSampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.producedSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.producedSampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getProducedSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.producedSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.producedSampleSearch"
                            },
                            "name": "getProducedSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Hold",
              "bracketValueFormula": "{{fetchedData.onHoldSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "On Hold Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.onHoldSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Mark As Production",
                          "showIf": "fn(MATCH_DEPARTMENT,QA)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsProduction",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/unHold",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "refreshPage",
                                "arg3Value": "TRUE",
                                "arg4Key": "requestMethod",
                                "arg4Value": "PATCH"
                              },
                              "name": "markAsProduction"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,

                      "pagination": {
                        "pageVariable": "fetchedData.onHoldSampleForm.page",
                        "serverItemsLengthVariable": "fetchedData.onHoldSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.onHoldSampleForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getOnHoldSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.onHoldSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.onHoldSampleForm"
                            },
                            "name": "getOnHoldSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Failed",
              "bracketValueFormula": "{{fetchedData.failedSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Failed Samples",
                      "disabled": "FALSE",
                      "items": "fetchedData.failedSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "__item.feedback",
                          "text": "Failure Reason",
                          "type": "formula",
                          "formula": "fn(CONDITIONAL,fn(NOT,{{_item.failureReason}}),{{__item.feedback}},{{__item.failureReason}})"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.failedSampleForm.page",
                        "serverItemsLengthVariable": "fetchedData.failedSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.failedSampleForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getFailedSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.failedSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.failedSampleForm"
                            },
                            "name": "getFailedSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Complete",
              "bracketValueFormula": "{{fetchedData.completeSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Complete Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.completeSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.completeSampleForm.page",
                        "serverItemsLengthVariable": "fetchedData.completeSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.completeSampleForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getCompleteSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.completeSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.completeSampleForm"
                            },
                            "name": "getCompleteSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Cancelled",
              "bracketValueFormula": "{{fetchedData.cancelledSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Cancelled Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.cancelledSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Created By"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "pagination": {
                        "pageVariable": "fetchedData.cancelledSampleForm.page",
                        "serverItemsLengthVariable": "fetchedData.cancelledSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.cancelledSampleForm.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "pageFunction": {
                              "name": "getCancelledSamples",
                              "type": "fnGetData",
                              "arg1Key": "apiUrl",
                              "arg1Value": "/api/v1/sample/search",
                              "arg2Key": "storeInVar",
                              "arg2Value": "fetchedData.cancelledSamples",
                              "arg3Key": "postData",
                              "arg3Value": "fetchedData.cancelledSampleForm"
                            },
                            "name": "getCancelledSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyCustomerId",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "__params.customerId",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customer",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Number"
        },
        "name": "copyCustomerId"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 4,
        "pageFunction": {
          "name": "copyCustomerData",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getCustomerData",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerDetails"
        },
        "name": "copyCustomerData"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultProductionSampleSearchObject",
        "pageFunction": {
          "name": "copyDefaultProductionSampleSearchObject",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductionSampleSearchObject",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productionSampleSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        }
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToProductionSampleSearchObject",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.productionSampleSearch.q.customer"
        },
        "name": "pushCustomerIdToProductionSampleSearchObject"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProductionSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productionSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.productionSampleSearch"
        },
        "name": "getProductionSamples"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultProducedSampleSearchObject",
        "pageFunction": {
          "name": "copyDefaultProducedSampleSearchObject",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProducedSampleSearchObject",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.producedSampleSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        }
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToProducedSampleSearchObject",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.producedSampleSearch.q.customer"
        },
        "name": "pushCustomerIdToProducedSampleSearchObject"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getProducedSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.producedSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.producedSampleSearch"
        },
        "name": "getProducedSamples"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPendingSampleSearchForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPendingSampleSearchForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.pendingSampleSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPendingSampleSearchForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToPendingSampleSearchForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.pendingSampleSearch.q.customer"
        },
        "name": "pushCustomerIdToPendingSampleSearchForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getPendingSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.pendingSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.pendingSampleSearch"
        },
        "name": "getPendingSamples"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultOpenSampleForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOpenSampleForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.openSampleSearchForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultOpenSampleForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToOpenSampleForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.openSampleSearchForm.q.customer"
        },
        "name": "pushCustomerIdToOpenSampleForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getOpenSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.openSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.openSampleSearchForm"
        },
        "name": "getOpenSamples"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultOnHoldSampleForm",
        "pageFunction": {
          "name": "copyDefaultOnHoldSampleForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultOnHoldSampleForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.onHoldSampleForm",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        }
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToOnHoldSampleForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.onHoldSampleForm.q.customer"
        },
        "name": "pushCustomerIdToOnHoldSampleForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getOnHoldSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.onHoldSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.onHoldSampleForm"
        },
        "name": "getOnHoldSamples"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCompleteSampleForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCompleteSampleForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.completeSampleForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultCompleteSampleForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToCompleteSampleForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.completeSampleForm.q.customer"
        },
        "name": "pushCustomerIdToCompleteSampleForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCompleteSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.completeSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.completeSampleForm"
        },
        "name": "getCompleteSamples"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultFailedSampleForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFailedSampleForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.failedSampleForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultFailedSampleForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToFailedSampleForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.failedSampleForm.q.customer"
        },
        "name": "pushCustomerIdToFailedSampleForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getFailedSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.failedSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.failedSampleForm"
        },
        "name": "getFailedSamples"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCancelledSampleForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCancelledSampleForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.cancelledSampleForm",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultCancelledSampleForm"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "pushCustomerIdToCancelledSampleForm",
          "type": "fnPushToArray",
          "arg1Key": "sourceVariable",
          "arg1Value": "fetchedData.customer",
          "arg2Key": "destinationVariable",
          "arg2Value": "fetchedData.cancelledSampleForm.q.customer"
        },
        "name": "pushCustomerIdToCancelledSampleForm"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getCancelledSamples",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/sample/search",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.cancelledSamples",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.cancelledSampleForm"
        },
        "name": "getCancelledSamples"
      }
    ],
    "functions": [
      {
        "name": "getDefaultProductionSampleSearchObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Production"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultPendingSampleSearchForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Pending"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultOpenSampleForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Open"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "copySelectedTableItem",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedSample",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object"
      },
      {
        "name": "getDefaultOnHoldSampleForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Hold"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCompleteSampleForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Complete"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultFailedSampleForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Failed"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCancelledSampleForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Cancelled"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultProducedSampleSearchObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Produced"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Open Prospect", "Open Customer", "Closed Prospect", "Closed Customer"]
        },
        "staticObject": true
      },
      {
        "name": "getCustomerData",
        "type": "fnFindInArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.customers.data",
        "arg2Key": "searchKey",
        "arg2Value": "_id",
        "arg3Key": "searchValue",
        "arg3Value": "fetchedData.customer"
      }
    ]
  },
  "forRole": "GENERAL_MANAGER,QA_MANAGER,SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,QA_TECHNICAL_EXECUTIVE,QA_QUALITY_EXECUTIVE,PRODUCTION_MANAGER,CUSTOMER_SERVICE_MANAGER",
  "visible": true,
  "routerPriority": 74
}